import * as types from './types'
import storage from '@/plugins/storage'
export default {
  passthrough: '',
  token: storage.session.getItem(types.SESSION_TOKEN_NAME),
  profile: JSON.parse(storage.session.getItem(types.SESSION_USER_PROFILE)),
  noVideo:false,
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/state.js